import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'

/**
 * Поля для drawer «Дополнительные поля»: без системных и табличных link-полей.
 */
export function filterDrawerVisibleFields(fields: ObjectInventoryField[]): ObjectInventoryField[] {
  return fields.filter(
    (field) => !field.is_system && !(field.is_table && field.link_target_type_id),
  )
}
